// extracted by mini-css-extract-plugin
module.exports = {"bold":"text_bold__1nIVx","underline":"text_underline__3HrVO","preserveLinebreaks":"text_preserveLinebreaks__Nu2gE"};